export const formatDaysAgo = (dateString) => {
  if (!dateString) return "N/A";

  // Parse the UTC date string and create a date object
  const date = new Date(dateString);

  // Get current time in user's timezone
  const now = new Date();

  // Ensure both dates are compared in the same timezone
  const userTimezoneOffset = now.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  const localDate = new Date(date.getTime() - userTimezoneOffset);

  // Calculate the difference in milliseconds
  const differenceInMilliseconds = now - localDate;

  // Convert to various time units
  const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
  const differenceInMinutes = Math.floor(differenceInSeconds / 60);
  const differenceInHours = Math.floor(differenceInMinutes / 60);
  const differenceInDays = Math.floor(differenceInHours / 24);
  const differenceInMonths = Math.floor(differenceInDays / 30); // Approximate months
  const differenceInYears = Math.floor(differenceInMonths / 12); // Approximate years

  if (differenceInYears > 0) {
    return differenceInYears === 1
      ? "1 year ago"
      : `${differenceInYears} years ago`;
  }
  // Return appropriate time difference string
  if (differenceInMonths > 0) {
    return differenceInMonths === 1
      ? "1 month ago"
      : `${differenceInMonths} months ago`;
  }
  // Return appropriate time difference string
  if (differenceInDays > 0) {
    return differenceInDays === 1
      ? "1 day ago"
      : `${differenceInDays} days ago`;
  }

  if (differenceInHours > 0) {
    return differenceInHours === 1
      ? "1 hour ago"
      : `${differenceInHours} hours ago`;
  }

  if (differenceInMinutes > 0) {
    return differenceInMinutes === 1
      ? "1 minute ago"
      : `${differenceInMinutes} minutes ago`;
  }

  if (differenceInSeconds > 0) {
    return differenceInSeconds === 1
      ? "1 second ago"
      : `${differenceInSeconds} seconds ago`;
  }

  return "Just now";
};
